
export function getTrackId(track) {
  return `${track.getType() + track.stream.id.replace(/[^a-z0-9\-]/gi, '')}`;
}


// WEBPACK FOOTER //
// ./src/shared/utils.js